import React from "react";
import DownloadEmployeeExcelButton from "./DownloadEmployeeExcelButton";

const Pagination = ({
    currentPage,
    totalPages,
    itemsPerPage,
    onPageChange,
    onItemsPerPageChange,
    buildFilters
}) => {

    const getPageNumbers = () => {
        if (totalPages <= 1) return [{ value: 1, type: 'number' }];

        const delta = 2;
        const result = [];
        const rangeStart = Math.max(2, currentPage - delta);
        const rangeEnd = Math.min(totalPages - 1, currentPage + delta);

        // Always first page
        result.push({ value: 1, type: 'number' });

        // Left ellipsis
        if (rangeStart > 2) {
            result.push({ value: '...', type: 'ellipsis' });
        }

        // Middle range
        for (let i = rangeStart; i <= rangeEnd; i++) {
            result.push({ value: i, type: 'number' });
        }

        // Right ellipsis
        if (rangeEnd < totalPages - 1) {
            result.push({ value: '...', type: 'ellipsis' });
        }

        // Always last page
        if (totalPages > 1) {
            result.push({ value: totalPages, type: 'number' });
        }

        return result;
    };

    return (

        <div className="paginationsr">

            <div className="pagination-buttons">

                {/* PREV */}
                <button
                    className="paginationsr-btn"
                    onClick={() =>
                        onPageChange(currentPage - 1)
                    }
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>

                {/* PAGE NUMBERS */}
                {getPageNumbers().map(({ value, type }, index) =>
                    type === 'ellipsis' ? (
                        <span key={`ellipsis-${index}`} className="paginationsr-ellipsis">
                            ...
                        </span>
                    ) : (
                        <button
                            key={`page-${value}`}
                            onClick={() => onPageChange(value)}
                            className={`paginationsr-btn ${currentPage === value ? 'active' : ''}`}
                        >
                            {value}
                        </button>
                    )
                )}

                {/* NEXT */}
                <button
                    className="paginationsr-btn"
                    onClick={() =>
                        onPageChange(currentPage + 1)
                    }
                    disabled={
                        currentPage === totalPages
                    }
                >
                    &raquo;
                </button>

            </div>

            {/* ITEMS PER PAGE */}
            <select
                className="items-per-page"
                value={itemsPerPage}
                onChange={(e) =>
                    onItemsPerPageChange(
                        Number(e.target.value)
                    )
                }
            >
                <option value={10}>
                    10 per page
                </option>

                <option value={15}>
                    15 per page
                </option>

                <option value={20}>
                    20 per page
                </option>

                <option value={50}>
                    50 per page
                </option>

            </select>

            <DownloadEmployeeExcelButton
                buildFilters={buildFilters}
            />

        </div>

    );

};

export default Pagination;